"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const icons_1 = require("@ant-design/icons");
const propertyBackDefault_webp_1 = __importDefault(require("../../../assets/images/propertyBackDefault.webp"));
const underline_1 = __importDefault(require("../../../components/underline"));
const Properties_1 = require("../../../hooks/Properties");
const AbstractPaymentStyle_1 = require("../abstractPayment/AbstractPaymentStyle");
const Text_1 = __importDefault(require("../../../components/shared/Text"));
const format_1 = require("../../../utils/format");
const AbstractCheckin = ({ propInfo, checkinReserveData }) => {
    var _a, _b;
    const [suiteReserve, setSuiteReserve] = (0, react_1.useState)({});
    const propertyContext = (0, Properties_1.useProperties)();
    (0, react_1.useEffect)(() => {
        if (checkinReserveData) {
            setSuiteReserve(checkinReserveData);
        }
    }, [checkinReserveData]);
    return (react_1.default.createElement(AbstractPaymentStyle_1.Container, null,
        react_1.default.createElement(antd_1.Col, { xs: {
                span: 24,
            }, sm: {
                span: 24,
            }, lg: 0 },
            react_1.default.createElement(antd_1.Row, { justify: "space-between", style: {
                    marginBottom: '20px',
                }, align: "middle" },
                react_1.default.createElement(AbstractPaymentStyle_1.TitleStyled, null, "Pagamento"),
                react_1.default.createElement(underline_1.default, null))),
        react_1.default.createElement(AbstractPaymentStyle_1.Building, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("img", { src: ((_b = (_a = propInfo === null || propInfo === void 0 ? void 0 : propInfo.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) || propertyBackDefault_webp_1.default, alt: "", loading: "lazy" })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Text_1.default, { size: 25 },
                    react_1.default.createElement(Text_1.default, { bold: true, color: "--main-color", size: 23 }, ` ${(propInfo === null || propInfo === void 0 ? void 0 : propInfo.name) || 'Carregando...'}`)),
                react_1.default.createElement(Text_1.default, { size: 17 }, propInfo === null || propInfo === void 0 ? void 0 : propInfo.city),
                react_1.default.createElement(Text_1.default, { size: 17 }, propInfo === null || propInfo === void 0 ? void 0 : propInfo.address))),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(AbstractPaymentStyle_1.Group, null,
            react_1.default.createElement(Text_1.default, { size: 17, bold: true }, "Entrada"),
            react_1.default.createElement(Text_1.default, { color: "--success", bold: true },
                (0, moment_1.default)(suiteReserve.firstNight).format('DD/MM/YYYY'),
                react_1.default.createElement(Text_1.default, null, "\u00A0a partir das\u00A0"),
                "15:00hrs")),
        react_1.default.createElement(AbstractPaymentStyle_1.Group, null,
            react_1.default.createElement(Text_1.default, { size: 17, bold: true }, "Sa\u00EDda"),
            react_1.default.createElement(Text_1.default, { color: "--main-color", bold: true },
                (0, moment_1.default)(suiteReserve.lastNight).format('DD/MM/YYYY'),
                react_1.default.createElement(Text_1.default, null, "\u00A0at\u00E9\u00A0"),
                "12:00hrs")),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(AbstractPaymentStyle_1.Group, null,
            react_1.default.createElement(Text_1.default, { size: 17, bold: true }, "H\u00F3spedes"),
            react_1.default.createElement(Text_1.default, null,
                +suiteReserve.guestsQtyString || react_1.default.createElement(icons_1.LoadingOutlined, null),
                ` hóspedes`)),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(antd_1.Row, { justify: "space-between" },
            react_1.default.createElement(Text_1.default, { size: 30, bold: true }, "Total"),
            react_1.default.createElement(Text_1.default, { bold: true, size: 20 },
                `R$ `,
                react_1.default.createElement(Text_1.default, { size: 30, bold: true }, (suiteReserve.totalPrice && (0, format_1.getFormattedDouble)(suiteReserve.totalPrice)) || react_1.default.createElement(icons_1.LoadingOutlined, null))))));
};
exports.default = AbstractCheckin;
